import React, { useState, useEffect, useRef } from "react";
import { authActions } from "../../../redux-store";
import { useDispatch, useSelector } from "react-redux";
import backend from "../../../api";
import { Navigate, useNavigate, useParams } from "react-router-dom";
// import './Auth.css';
import { useLocation } from 'react-router-dom';
import { motion, easeOut, AnimatePresence } from 'framer-motion';
import Classes from './Auth.module.css'
import CryptoJS from 'crypto-js';
import Logo from "../Home/Components/Logo/Logo";
import { BulbIcon, CalenderSimpleIcon, DollarIcon, SearchIcon } from "../../../utils/Icons";

const CursorIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 320 512"><path d="M0 55.2L0 426c0 12.2 9.9 22 22 22c6.3 0 12.4-2.7 16.6-7.5L121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320l118.1 0c12.2 0 22.1-9.9 22.1-22.1c0-6.3-2.7-12.3-7.4-16.5L38.6 37.9C34.3 34.1 28.9 32 23.2 32C10.4 32 0 42.4 0 55.2z" /></svg>
)
const FileIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 384 512"><path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM80 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2L80 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l8.2 0c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8 54.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349l-9.8 32.8z" /></svg>
)
const ShieldIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 576 512"><path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 47-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52c0 56.6 18.9 148 94.2 208.3c-9 4.8-19.3 7.6-30.2 7.6L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zm39.1 97.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8l0 187.8c68.2-33 91.5-99 95.4-149.7z" /></svg>
)

const LoadingSpinner = () => (
    <div class="loadingio-spinner-eclipse-nq4q5u6dq7r">
        <div class="ldio-x2uulkbinbj">
            <div></div>
        </div>
    </div>
)

function Signup() {
    const [state, setState] = useState("signup");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setconfirmPassword] = useState("");
    const [loading, setLoading] = useState();
    const [incorrectError, setincorrectError] = useState(false);
    const dispatch = useDispatch();
    const navigateTo = useNavigate();
    const [showEye, setshowEye] = useState(false);
    const [showEye2, setshowEye2] = useState(false);
    const [passwordMatchingError, setpasswordMatchingError] = useState(false);
    const [passwordLengthError, setpasswordLengthError] = useState(false);
    const [userAlreadyExistError, setUserAlreadyExistError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [codeSentMsg, setcodeSentMsg] = useState(false);
    const [IncorrectCode, setIncorrectCode] = useState(false);
    const [userCode, setUserCode] = useState('');
    const [userId, setUserId] = useState('');

    const location = useLocation();
    const { role } = useParams();

    if (role !== 'mentor' && role !== 'mentee') {
        return <Navigate to="/join" replace />;
    }

    const isMentor = role === 'mentor';

    const code = Math.floor(Math.random() * 10000).toString();

    const message = `verification code is ${code}`;

    const switchToVerify = () => {
        setincorrectError(false);
        if (password !== confirmPassword) {
            setpasswordMatchingError(true);
            setTimeout(() => {
                setpasswordMatchingError(false);
            }, 5000);
            return;
        }

        if (password && password.length <= 5) {
            setpasswordLengthError(true);
            setTimeout(() => {
                setpasswordLengthError(false);
            }, 10000);
            return;
        }

        sendMail();
    }

    const switchToSignIn = () => {
        setincorrectError(false);
        setState("signin");
    }

    const sendMail = async () => {
        setLoading(true);

        try {
            const encrypted = CryptoJS.AES.encrypt(code, 'secret-key').toString();
            sessionStorage.setItem('encryptedData', encrypted);
            const encryptedDataFromStorage = sessionStorage.getItem('encryptedData');

            if (encryptedDataFromStorage) {
                const bytes = CryptoJS.AES.decrypt(encryptedDataFromStorage, 'secret-key');
                const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
                // Optionally use decryptedData if needed
            }

            const body = {
                username: "User",
                email: email,
                message
            };
            const resp = await backend.post("/verify/sendemail", body);

            if (resp.status === 200) {
                // console.log('Verification code sent successfully');
                setcodeSentMsg(true);
                setTimeout(() => {
                    setcodeSentMsg(false);
                }, 60000);
                setState('verify');
            } else if (resp.status === 400) {
                setUserAlreadyExistError(true);
                setTimeout(() => {
                    setUserAlreadyExistError(false);
                }, 10000);
            } else if (resp.status === 500) {
                alert('Server error occurred. Please try again later.');
            } else {
                // Handle other unexpected statuses
                alert('An unexpected error occurred. Please try again.');
            }
        } catch (error) {
            // This block will now only catch network errors or issues in the request setup,
            // not HTTP errors like 400 or 500 which are handled above
            console.log(error?.response?.data?.message);
            setUserAlreadyExistError(true);
            setErrorMessage(error?.response?.data?.message);
            setTimeout(() => {
                setUserAlreadyExistError(false);
                setErrorMessage('');
            }, 10000);
            // alert(error?.response?.data?.message);
        } finally {
            setLoading(false);
        }
    };

    const SignUpHandler = async () => {
        const sideBar = sessionStorage.getItem('navBtn');
        setLoading(true)

        try {
            if (email != "" && email != null && email != undefined &&
                password != "" && password != null && password != undefined
            ) {
                if (email.includes("@") && password.length > 5) {
                    const isSignup = await dispatch(
                        authActions.signUp(email, password, role)
                    );
                    if (isSignup) {
                        setLoading(false)
                        console.log(isSignup)
                        // setState(4)
                        if (location?.state?.data === "toTemplate") {
                            navigateTo(`/templates`);
                        } else {
                            navigateTo(`/onboard/${role}`);
                        }
                    }
                    if (!isSignup) {
                        setLoading(false)
                        setincorrectError(true);
                    }
                }
                else {
                    setLoading(false)
                    setpasswordLengthError(true);
                    setTimeout(() => {
                        setpasswordLengthError(false);
                    }, 10000);
                }
            } else {
                setLoading(false)
                setpasswordLengthError(true);
                setTimeout(() => {
                    setpasswordLengthError(false);
                }, 10000);
            }
        } catch (e) {
            setLoading(false)
            alert("Network Error");
        }
    };

    const handleSignUpSubmit = (e) => {
        e.preventDefault();
        if (email?.startsWith('demo.evala')) {
            SignUpHandler()
        } else {
            switchToVerify()
        }
    }

    const onCLickVerify = async (e) => {
        e.preventDefault();
        setLoading(true);
        const encryptedDataFromStorage = sessionStorage.getItem('encryptedData');
        if (encryptedDataFromStorage) {
            const bytes = CryptoJS.AES.decrypt(encryptedDataFromStorage, 'secret-key');
            const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

            if (userCode === decryptedData) {
                SignUpHandler();
            } else {
                setIncorrectCode(true);
                setLoading(false);
                setTimeout(() => {
                    setIncorrectCode(false);
                }, 1000);
            }
        }
    }

    return (
        <>
            <div className={Classes.signUp}>
                <div className={Classes.signUpGridLeft} >
                    <AnimatePresence mode="wait">
                        {state === "signup" && (
                            <motion.div
                                key='signup'
                                initial={{ opacity: 0, x: -10 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -10 }}
                                transition={{
                                    duration: 0.5,
                                    ease: easeOut,
                                    delay: 0.3
                                }}
                            >
                                <form onSubmit={handleSignUpSubmit} className={Classes.signUpInnerCon}>
                                    <a href="/" className={Classes.miniLogo2} style={{ textDecoration: 'none' }} >
                                        <h1 style={{ color: 'black' }} >Mentr</h1>
                                    </a>
                                    <h5 className={Classes.heading2} >Sign up</h5>
                                    <p className={Classes.subtitle} style={{ textAlign: 'start' }} >
                                        {isMentor ?
                                            "Create a free Mentr account to get paid to mentor. Set your rate, connect your calendar, and start meeting mentees."
                                            :
                                            "Create a free Mentr account to filter mentors, book meetings, and get personalized guidance."
                                        }
                                    </p>
                                    <input
                                        onChange={(e) => setEmail(e.target.value)}
                                        type="email"
                                        placeholder="Enter your email"
                                        required
                                        className={`${`${Classes.inputField} ${Classes.mb20}`} ${incorrectError || userAlreadyExistError ? Classes.inputError : ''}`}
                                        style={{ width: '100%' }}
                                    />
                                    <div className={`${`${Classes.passwordCon} ${Classes.mb20}`} ${incorrectError || passwordMatchingError || passwordLengthError ? Classes.inputError : ''}`} >
                                        <input
                                            onChange={(e) => setPassword(e.target.value)}
                                            type={showEye ? "text" : "password"}
                                            placeholder="Enter your password"
                                            required
                                        />
                                        {showEye ?
                                            <>
                                                <svg onClick={() => { setshowEye(!showEye) }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z" /></svg>
                                            </>
                                            :
                                            <>
                                                <svg onClick={() => { setshowEye(!showEye) }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3l-41.9-33C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5zm-88-69.3L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8z" /></svg>
                                            </>
                                        }
                                    </div>
                                    <div className={`${`${Classes.passwordCon} ${Classes.mb20}`} ${incorrectError || passwordMatchingError || passwordLengthError ? Classes.inputError : ''}`} >
                                        <input
                                            onChange={(e) => setconfirmPassword(e.target.value)}
                                            type={showEye2 ? "text" : "password"}
                                            placeholder="Confirm password"
                                            required
                                        />
                                        {showEye2 ?
                                            <>
                                                <svg onClick={() => { setshowEye2(!showEye2) }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z" /></svg>
                                            </>
                                            :
                                            <>
                                                <svg onClick={() => { setshowEye2(!showEye2) }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3l-41.9-33C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5zm-88-69.3L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8z" /></svg>
                                            </>
                                        }
                                    </div>

                                    <p className={Classes.signupLink} style={{ maxWidth: '100%' }} >
                                        By creating an account, you agree to the
                                        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer"  >
                                            <button type="button" className={Classes.linkButton}> Privacy Policy </button>
                                        </a>
                                        <span> and </span>
                                        <a href="/terms-of-service" target="_blank" rel="noopener noreferrer" >
                                            <button type="button" className={Classes.linkButton}> Terms of Service </button>
                                        </a>
                                    </p>
                                    <button type="submit" className={`${Classes.button} ${Classes.signInButton}`} disabled={loading} >
                                        Create an account
                                        {loading && <LoadingSpinner />}
                                    </button>
                                    <p className={Classes.signupLink2}>
                                        Have an account?
                                        <button type="button" onClick={() => { navigateTo('/login') }} className={Classes.linkButton}>
                                            Sign in
                                        </button>
                                    </p>
                                </form>
                            </motion.div>
                        )}
                        {state === "verify" && (
                            <motion.div
                                key='verify'
                                initial={{ opacity: 0, x: -10 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -10 }}
                                transition={{
                                    duration: 0.5,
                                    ease: easeOut,
                                    delay: 0.3
                                }}
                            >
                                <form onSubmit={onCLickVerify} className={Classes.signUpInnerCon}>
                                    <a href="/" className={Classes.miniLogo2} >
                                        <h1 style={{ color: 'black' }} >Mentr</h1>
                                    </a>
                                    <h1 className={Classes.heading2}>Enter verification code</h1>
                                    {codeSentMsg && <p className={Classes.subtitle} style={{ textAlign: 'start' }} > A code was sent to your email </p>}
                                    <br />
                                    <input
                                        onChange={(e) => setUserCode(e.target.value)}
                                        type="number"
                                        value={userCode}
                                        placeholder="Enter your code here"
                                        required
                                        className={`${`${Classes.inputField} ${Classes.mb10}`} ${incorrectError ? Classes.inputError : ''}`}
                                        style={{ width: '100%' }}
                                    />
                                    {IncorrectCode && <p className={Classes.error}>*Incorrect code.</p>}
                                    <button type="submit" className={`${Classes.button} ${Classes.signInButton}`} disabled={loading} >
                                        Verify
                                        {loading && <LoadingSpinner />}
                                    </button>
                                    <p className={Classes.signupLink2}>
                                        Haven't received the code?
                                        <button type="button" onClick={() => switchToVerify()} className={Classes.linkButton}>
                                            Resend code
                                        </button>
                                    </p>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </form>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                        duration: 0.3,
                        ease: easeOut,
                    }}
                    className={Classes.signUpGridRight}
                >
                    <motion.div
                        initial={{ opacity: 0, x: 10 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{
                            duration: 0.5,
                            ease: easeOut,
                            delay: 0.3
                        }}
                        className={Classes.signUpInnerCon2}
                    >
                        <h5 className={Classes.title3} > Start today for free </h5>
                        <div className={Classes.flexAlign2} >
                            <svg xmlns="http://www.w3.org/2000/svg" height="15px" fill="white" viewBox="0 0 512 512"><path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z" /></svg>
                            <h5 className={Classes.miniText} >No credit card required</h5>
                        </div>
                        <div className={Classes.infoElem} >
                            <div className={Classes.infoImgBox} >
                                {isMentor ?
                                    <img src="/assets/icons/mentor-1.png" draggable={false} />
                                    :
                                    <img src="/assets/icons/mentee-1.png" draggable={false} />
                                }
                            </div>
                            <div className={Classes.infoElemRight} >
                                <h5 className={Classes.title5} >
                                    {isMentor ? "Monetize Your Expertise" : "Find Your Perfect Match"}
                                </h5>
                                <h5 className={Classes.miniText2} >
                                    {isMentor ? "Set your own rates, connect your calendar, and get paid to share your knowledge—on your terms."
                                        : "Use smart filters to browse mentors by expertise, price, availability, and ratings—get exactly what you need."}
                                </h5>
                            </div>
                        </div>
                        <div className={Classes.infoElem} >
                            <div className={Classes.infoImgBox} >
                                {isMentor ?
                                    <img src="/assets/icons/mentor-2.png" draggable={false} />
                                    :
                                    <img src="/assets/icons/mentee-2.png" draggable={false} />
                                }
                            </div>
                            <div className={Classes.infoElemRight} >
                                <h5 className={Classes.title5} >
                                    {isMentor ? "Get Discovered by Mentees" : "Book Instantly"}
                                </h5>
                                <h5 className={Classes.miniText2} >
                                    {isMentor ? "Show up in filtered searches by skill, industry, and experience—so the right people find you."
                                        : "Seamlessly book sessions through Calendly, Cal, and more. No back-and-forth, just instant scheduling."}
                                </h5>
                            </div>
                        </div>
                        <div className={Classes.infoElem} >
                            <div className={Classes.infoImgBox} >
                                {isMentor ?
                                    <img src="/assets/icons/mentor-3.png" draggable={false} />
                                    :
                                    <img src="/assets/icons/mentee-3.png" draggable={false} />
                                }
                            </div>
                            <div className={Classes.infoElemRight} >
                                <h5 className={Classes.title5} >
                                    {isMentor ? "Simplified Scheduling" : "Pay as You Go"}
                                </h5>
                                <h5 className={Classes.miniText2} >
                                    {isMentor ? "Sync your Calendly or Cal.com once—mentees book directly based on your real-time availability."
                                        : "Only pay per session—no subscriptions. Secure payments with a transparent fee structure."}
                                </h5>
                            </div>
                        </div>
                        <div className={Classes.infoElem} >
                            <div className={Classes.infoImgBox} >
                                {isMentor ?
                                    <img src="/assets/icons/mentor-4.png" draggable={false} />
                                    :
                                    <img src="/assets/icons/mentee-4.png" draggable={false} />
                                }
                            </div>
                            <div className={Classes.infoElemRight} >
                                <h5 className={Classes.title5} >
                                    {isMentor ? "No Subscriptions, No Hassle" : "Real Reviews, Trusted Mentors"}
                                </h5>
                                <h5 className={Classes.miniText2} >
                                    {isMentor ? "You earn per session, we take a small fee—no monthly commitments or upfront costs."
                                        : "Every mentor is rated by real mentees. See honest feedback before you book."}
                                </h5>
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            </div>
        </>
    );
}

export default Signup;
